import { Injectable } from '@angular/core';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { Observable, throwError } from "rxjs/index";
import { catchError, map } from "rxjs/operators";
import { MaklerPaketHist } from "./Model/MaklerPaketHist";

@Injectable()
export class MpHistoryService extends RESTService<MaklerPaketHist>{

  constructor(
    public http:HttpInterceptorService
  ) {
    super (http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/mphistid'
    });
  }

  loadMpHistById(id: number): Observable<MaklerPaketHist>  {
    let res = this.http.get(`${environment.apiHost}` + '/makpak/mphistid?id=' + id).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: MaklerPaketHist) => {
        if (result != null) {
          return result;
        }
      }));

    return res;
  }
}
